// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"404":"8aced656c588d9aa6cae","616":"2921d4fdf39d8942a0da","884":"4bee9b1c05eea75660cd"}[chunkId] + ".css";
};